import { useMemo } from 'react';
import { getPortalUser } from '../auth/portalSession';

export function usePortalRole(user) {
  return useMemo(() => {
    const groups =
      user?.signInUserSession?.accessToken?.payload?.['cognito:groups'] || [];
    const isAdmin = Array.isArray(groups)
      ? groups.includes('admin')
      : groups === 'admin';
    const role = isAdmin
      ? 'admin'
      : Array.isArray(groups) && groups.length > 0
        ? groups[0]
        : 'driver';
    return { isAdmin, role, groups };
  }, [user]);
}

export async function currentUserIsAdmin() {
  try {
    const user = await getPortalUser();
    const groups = user?.signInUserSession?.accessToken?.payload?.['cognito:groups'] || [];
    return Array.isArray(groups) ? groups.includes('admin') : groups === 'admin';
  } catch (e) {
    return false;
  }
}
